import { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import {
    FormControlLabel, Checkbox, Autocomplete,
    IconButton, Grid, Box, Select,
    FormControl, TextField, MenuItem, InputLabel,
    Container, Stack, Button, InputAdornment,
} from '@mui/material';
import moment from 'moment';
import MaterialReactTable from 'material-react-table';
import { v4 as uuidv4 } from 'uuid';   ///me da un unico id para poner en los pedidos
import Notify from '../../../Notify';
import Title from '../../../Title';
import { Delete, AddCircleOutline } from '@mui/icons-material';
import { getData, postData } from '../../../../services/library';
import Modalcondicionnull from './Modalcondicionnull';
import { enviarmails, logEventos } from '../../../../services/services';
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { UrlApi } from '../../../../services/apirest';
import { DownloadFiles, ViewUploadFile } from '../../../../services/DownloadFiles';
import { AdjuntoField, AdjuntoFileCard } from '../../../Form/AdjuntoField';
import { formatoImporte } from '../../formatoImporte';

export default function GenerarOrdenes(props) {
    const globalTheme = useTheme();
    const [bonificacionPesos, setBonificacionPesos] = useState(null);
    const [bonificacionPorcentaje, setBonificacionPorcentaje] = useState(null);
    const [totalFinal, setTotalFinal] = useState();
    // const [proveedores, setProveedores] = useState(null);
    const [proveedores, setProveedores] = useState([]);
    const [proveedorSelected, setproveedorSelected] = useState(null);
    const [condiciones, setCondiciones] = useState(null);
    const [tipoMoneda, settipoMoneda] = useState(null);
    const [sucursales, setSucursales] = useState(null);
    const [vehiculos, setVehiculos] = useState(null)
    const [uuid, setUuid] = useState(uuidv4());
    const [condVentaNew, setCondVentaNew] = useState(null);
    const [subtotal, setsubtotal] = useState(0);
    const [articulos, setArticulos] = useState([]);
    const [medidas, setmedidas] = useState(null);
    const [disbtn, setdisbtn] = useState(false);
    const [empresas, setempresas] = useState(null);
    const [modalVacio, setmodalVacio] = useState(false);
    const [usuarios, setUsuarios] = useState([]);
    const [usuarioSelected, setusuarioSelected] = useState();
    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });
    const [presupuestos, setPresupuestos] = useState([]);
    const [cargandoPresupuesto, setCargandoPresupuesto] = useState(false);
    const [errorPresupuesto, setErrorPresupuesto] = useState("");

    const [datosFormulario, setDatosFormulario] = useState({
        tipo_moneda: 83,
        id_proveedor: null,
        iva_incluido: null,
        pago_anticipado: null,
        condicion_venta: null,
        uuid_ordencompra: uuid,
        id_sucursal: null,
        id_vehiculo: null,
        fecha_entrega: null,
        comentarios_internos: null,
        observaciones: null,
        saldo_pendiente: 1,
        usuario_crea: localStorage.getItem('user'),
        origen: "manual",
        facturar_a_empresa: null,
        usuario_autoriza: null
    });

    const [datosLista, setDatosLista] = useState([{
        cantidad: null,
        usuario: localStorage.getItem('user'),
        uuid_ordencompra: uuid,
        precio_unitario: null,
        subtotal: null,
        bonificacion_pesos: null,
        bonificacion_porcentaje: null,
        id_articulo: null,
        id_unidad_medida: null,
        material: '',
        checked: true
    }]);

    useEffect(() => {
        // getData('/proveedores', setProveedores)
        getData('/desplegables/tipoMoneda', settipoMoneda)
        getData('/condicion_pago', setCondiciones)
        getData('/sucursales', setSucursales)
        getData('/stock_articulos', setArticulos)
        getData("/unidad_medida", setmedidas);
        getData('/empresas', setempresas)
        getData('/autorizantes_compras',
            (data) => {
                const filtrados = data.filter((d) => d.nivel === 4);
                // console.log("filtrados", filtrados);
                setUsuarios(filtrados);
                setusuarioSelected(filtrados[0]?.usuario)
            });
    }, []);

    useEffect(() => {
        if (usuarios) {
            setDatosFormulario((prev) => ({
                ...prev,
                usuario_autoriza: usuarioSelected
            }))
        }
    }, [usuarios])

    // console.log(usuarioSelected);


    const getBonificacionPorcentaje = () => {
        if (!!subtotal && !!bonificacionPorcentaje) {
            setTotalFinal(subtotal - (subtotal * bonificacionPorcentaje / 100))
        } else if (!!subtotal && !!bonificacionPesos) {
            setTotalFinal(subtotal - bonificacionPesos)
        }
        else {
            setTotalFinal(subtotal)
        }
    };

    useEffect(() => {
        if (proveedorSelected && proveedorSelected.id_condicionventa === null) {
            setmodalVacio(true)
        }
    }, [proveedorSelected, setproveedorSelected]);

    useEffect(() => {
        getBonificacionPorcentaje()
    }, [bonificacionPesos, bonificacionPorcentaje, subtotal]);

    useEffect(() => {
        getData('/vehiculos/sucursal/' + datosFormulario.id_sucursal, setVehiculos)
    }, [datosFormulario.id_sucursal]);

    const getPresupuestos = useCallback(() => {
        fetch(UrlApi + "/uploadfiles/todownload/" + datosFormulario.uuid_ordencompra)
            .then((res) => res.json())
            .then((data) => setPresupuestos(Array.isArray(data) ? data : []))
            .catch(() => setPresupuestos([]));
    }, [datosFormulario.uuid_ordencompra]);

    useEffect(() => {
        getPresupuestos();
    }, [getPresupuestos]);

    const handlePresupuestoChange = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (!file) return;

        setCargandoPresupuesto(true);
        setErrorPresupuesto("");
        const data = new FormData();
        data.append("uid", datosFormulario.uuid_ordencompra);
        data.append("archivo", file);

        try {
            const res = await fetch(UrlApi + "/uploadfiles/uploadfiles", {
                method: "POST",
                body: data,
            });
            const body = await res.json().catch(() => ({}));
            if (!res.ok) {
                throw new Error(body?.message || "No se pudo cargar el archivo");
            }
            setNotificacion({
                open: true,
                mensaje: body?.message || "Archivo cargado",
                severity: "success",
                color: "",
            });
            getPresupuestos();
        } catch (err) {
            setErrorPresupuesto(err.message || "No se pudo cargar el archivo");
        } finally {
            setCargandoPresupuesto(false);
        }
    };

    const quitarPresupuesto = async (archivo) => {
        if (!window.confirm("Usted está por eliminar el archivo: " + archivo.nombre)) return;

        try {
            const res = await fetch(UrlApi + "/uploadfiles/todownload/" + archivo.id, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
            });
            if (!res.ok) {
                setErrorPresupuesto("No se borro el archivo");
                return;
            }
            setErrorPresupuesto("");
            setNotificacion({
                open: true,
                mensaje: "Archivo borrado",
                severity: "success",
                color: "",
            });
            getPresupuestos();
        } catch (err) {
            setErrorPresupuesto("No se borro el archivo");
        }
    };

    useEffect(() => {
        proveedorSelected &&
            setCondVentaNew(proveedorSelected.id_condicionventa);
    }, [proveedorSelected, setproveedorSelected]);

    const handleOnClickCheckBox = (e) => {
        setDatosFormulario({ ...datosFormulario, [e.target.name]: e.target.checked })
    };

    const handleChecked = (index, checked) => {
        setDatosLista((prev) =>
            prev.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        checked,
                        id_articulo: checked ? item.id_articulo : null,
                        material: checked ? '' : item.material || '',
                        id_unidad_medida: checked ? null : item.id_unidad_medida || null,
                    }
                    : item
            )
        );
    };

    const almacenar = (e) => {
        setDatosFormulario({ ...datosFormulario, [e.target.name]: e.target.value ? e.target.value : "" })
    };

    const setearCondicion = (e) => {
        setCondVentaNew(e.target.value);
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%"
    };

    const guardarOrdenCompra = async (e) => {
        e.preventDefault();

        if (!validarFormulario()) return;

        try {
            setdisbtn(true);

            // Crear OC
            const response = await fetch(`${UrlApi}/ordencompra/guardaproveedor`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    orden: {
                        id_proveedor: proveedorSelected.id,
                        comentarios_internos: datosFormulario.comentarios_internos,
                        uuid_ordencompra: datosFormulario.uuid_ordencompra,
                        pago_anticipado: datosFormulario.pago_anticipado,
                        iva_incluido: datosFormulario.iva_incluido,
                        condicion_venta: condVentaNew,
                        tipo_moneda: datosFormulario.tipo_moneda,
                        total: totalFinal,
                        usuario: localStorage.getItem("user"),
                        fecha_entrega: datosFormulario.fecha_entrega,
                        id_estado: 89,
                        bonificacion_pesos: bonificacionPesos,
                        bonificacion_porcentaje: bonificacionPorcentaje,
                        observaciones: datosFormulario.observaciones,
                        id_sucursal: datosFormulario.id_sucursal,
                        id_vehiculo: datosFormulario.id_vehiculo,
                        usuario_crea: datosFormulario.usuario_crea,
                        saldo_pendiente: 1,
                        origen: datosFormulario.origen,
                        facturar_a_empresa: datosFormulario.facturar_a_empresa,
                        usuario_autoriza: usuarioSelected,
                        cuit_proveedor: proveedorSelected.cuit,
                    },
                    ...proveedorSelected?.padron ? {
                        nuevoProveedor: {
                            inactivo: 0,
                            nro_cuit: proveedorSelected.cuit.trim(),
                            razon_social: proveedorSelected.denominacion.trim(),
                            // pequeno:1, 
                            id_condicionventa: condVentaNew,
                            usuario: localStorage.getItem("user"),
                            observaciones: "Proveedor cargado por seleccion en carga de ORDEN DE COMPRA."
                        }
                    } : {}
                }),
            });

            const data = await response.json();

            // Mostrar número de OC
            await new Promise((resolve) => {
                alert(`Se creó la OC Nº ${data.nro_oc}`);
                resolve();
            });

            enviarmails(
                usuarioSelected.email,
                "Solicitud de orden de compra",
                `<p>Se generó una nueva solicitud de orden de compra.</p>`
            );

            // Guardar materiales
            guardarListaMateriales(e);

            // Cerrar formulario si corresponde
            handleClose();

        } catch (error) {
            console.error("Error al generar nueva orden de compra", error);
        }
    };

    const guardarListaMateriales = async (e) => {
        postData(e,
            '/lista_materiales',
            {
                datosLista
            },
            setNotificacion,
            logEventos("Generar orden d compra", "Generar ordenes", "Orden de compra", localStorage.getItem("user")))
    };

    const handleClose = () => {
        props.tabla(true)
        props.alta(false)
        props.tab(true)
    };

    const agregarLinea = () => {
        const nuevaLinea = { id: uuidv4(), id_unidad_medida: null, material: null, cantidad: null, id_articulo: null, usuario: localStorage.getItem('user'), uuid_requerimiento: datosFormulario.uuid_requerimiento, uuid_ordencompra: datosFormulario.uuid_ordencompra, precio_unitario: null, bonificacion_pesos: null, bonificacion_porcentaje: null };
        setDatosLista((prevLineas) => [...prevLineas, nuevaLinea]);
    };

    const deshacerAlmacenar = (index) => {
        if (datosLista.length > 1) {
            const values = [...datosLista];
            values.splice(index, 1);
            setDatosLista(values)
        }
    };

    const handleArticuloChange = (index, selectedArticulo) => {
        setDatosLista((prevLineas) =>
            prevLineas.map((linea, i) =>
                i === index ? { ...linea, id_articulo: selectedArticulo?.id_articulo || null } : linea,

            )
        );
    };

    const calcularSubtotalPesos = (cantidad, precio, bonificacion_pesos) => {
        const cantidadNumerica = parseFloat(cantidad);
        const precioNumerico = parseFloat(precio);
        const bonificacionNumerico = parseFloat(bonificacion_pesos) || 0;
        return (cantidadNumerica * precioNumerico) - bonificacionNumerico;
    };

    const calcularSubtotalPorcentaje = (cantidad, precio, bonificacion_porcentaje) => {
        const cantidadNumerica = parseFloat(cantidad);
        const precioNumerico = parseFloat(precio);
        const bonificacionPorcentaje = parseFloat(bonificacion_porcentaje) || 0;
        const bonificacionDecimal = bonificacionPorcentaje / 100;
        return cantidadNumerica * precioNumerico * (1 - bonificacionDecimal);
    };

    const esValorNoNegativo = (valor) => {
        if (valor === '' || valor === null || valor === undefined) return true;
        const texto = String(valor).trim().replace(',', '.');
        if (texto === '' || texto === '.') return true;
        if (texto.includes('-')) return false;
        const numero = Number(texto);
        return !Number.isNaN(numero) && numero >= 0;
    };

    const bloquearSignoNegativo = (e) => {
        if (e.key === '-' || e.key === 'Subtract') {
            e.preventDefault();
        }
    };

    // Funciones de manejo de cambios
    const handleCantidadChange = (index, cantidad) => {
        if (!esValorNoNegativo(cantidad)) return;
        setDatosLista((prevLineas) =>
            prevLineas.map((linea, i) =>
                i === index ? { ...linea, cantidad } : linea
            )
        );
    };

    const handleMaterialChange = (index, material) => {
        setDatosLista((prevLineas) =>
            prevLineas.map((linea, i) =>
                i === index ? { ...linea, material } : linea
            )
        );
    };

    const handleMedidaChange = (index, id_unidad_medida) => {
        setDatosLista((prevLineas) =>
            prevLineas.map((linea, i) =>
                i === index ? { ...linea, id_unidad_medida } : linea
            )
        );
    };

    const handlePrecioChange = (index, precio_unitario) => {
        if (!esValorNoNegativo(precio_unitario)) return;
        const valorNumerico = parseFloat(precio_unitario.toString().replace(',', '.')) || 0;

        setDatosLista((prevDatosLista) =>
            prevDatosLista.map((linea, i) => {
                if (i === index) {
                    const subtotal = linea.bonificacion_pesos
                        ? calcularSubtotalPesos(linea.cantidad, valorNumerico, linea.bonificacion_pesos)
                        : calcularSubtotalPorcentaje(linea.cantidad, valorNumerico, linea.bonificacion_porcentaje);

                    return {
                        ...linea,
                        precio_unitario: valorNumerico,
                        subtotal,
                    };
                }
                return linea;
            })
        );
    };

    const handleBonificacionPorcentajeChange = (index, bonificacion_porcentaje) => {
        if (!esValorNoNegativo(bonificacion_porcentaje)) return;
        setDatosLista((prevLineas) =>
            prevLineas.map((linea, i) =>
                i === index
                    ? {
                        ...linea,
                        bonificacion_porcentaje,
                        subtotal: calcularSubtotalPorcentaje(linea.cantidad, linea.precio_unitario, bonificacion_porcentaje),
                    }
                    : linea
            )
        );
    };

    const handleBonificacionPesosChange = (index, bonificacion_pesos) => {
        if (!esValorNoNegativo(bonificacion_pesos)) return;
        setDatosLista((prevLineas) =>
            prevLineas.map((linea, i) =>
                i === index
                    ? {
                        ...linea,
                        bonificacion_pesos,
                        subtotal: calcularSubtotalPesos(linea.cantidad, linea.precio_unitario, bonificacion_pesos),
                    }
                    : linea
            )
        );
    };

    // Función para calcular el total
    const getTotal = (datosLista, setSubtotal) => {
        const total = datosLista.reduce((acc, lista) => {
            const subtotal = parseFloat(lista.subtotal) || 0;
            return isNaN(subtotal) ? acc : acc + subtotal;
        }, 0);
        setSubtotal(total);
    };

    const validarFormulario = () => {
        const errors = [];

        // Validaciones generales
        if (!proveedorSelected) errors.push('Debe seleccionar un proveedor');
        if (!condVentaNew) errors.push('Debe seleccionar una condición de venta');
        if (!datosFormulario.facturar_a_empresa) errors.push('Debe seleccionar una empresa para facturar');
        if (condVentaNew === 20 && !datosFormulario.comentarios_internos) {
            errors.push("Los comentarios internos son obligatorios para la condición 'Otras'");
        }
        if (!usuarioSelected) errors.push('Debe seleccionar un usuario');
        if (bonificacionPesos !== null && bonificacionPesos !== '' && !esValorNoNegativo(bonificacionPesos)) {
            errors.push('La bonificación en pesos no puede ser negativa');
        }
        if (bonificacionPorcentaje !== null && bonificacionPorcentaje !== '' && !esValorNoNegativo(bonificacionPorcentaje)) {
            errors.push('La bonificación en porcentaje no puede ser negativa');
        }
        if (totalFinal !== null && Number(totalFinal) < 0) {
            errors.push('El total no puede ser negativo');
        }
        // Validación de datosLista
        if (datosLista && Array.isArray(datosLista)) {
            datosLista.forEach((item, index) => {
                const erroresItem = [];

                if (item.cantidad === null || item.cantidad === undefined || item.cantidad <= 0) {
                    erroresItem.push('cantidad inválida');
                }

                const sinArticuloYMaterial = (!item.id_articulo && (!item.material || item.material === ''));
                if (sinArticuloYMaterial) {
                    erroresItem.push('falta artículo o descripción');
                }

                if (item.precio_unitario === null || item.precio_unitario === '') {
                    erroresItem.push('precio unitario faltante');
                } else if (Number(item.precio_unitario) < 0) {
                    erroresItem.push('el precio no puede ser negativo');
                }

                if (item.bonificacion_pesos !== null && item.bonificacion_pesos !== '' && Number(item.bonificacion_pesos) < 0) {
                    erroresItem.push('la bonificación en pesos no puede ser negativa');
                }

                if (item.bonificacion_porcentaje !== null && item.bonificacion_porcentaje !== '' && Number(item.bonificacion_porcentaje) < 0) {
                    erroresItem.push('la bonificación en porcentaje no puede ser negativa');
                }

                if (item.subtotal === null || item.subtotal === '') {
                    erroresItem.push('subtotal faltante');
                } else if (Number(item.subtotal) < 0) {
                    erroresItem.push('el subtotal no puede ser negativo');
                }

                // if (item.uuid_ordencompra === null || item.uuid_ordencompra === '') {
                //     erroresItem.push('uuid_ordencompra faltante');
                // }

                if (erroresItem.length > 0) {
                    errors.push(`Ítem #${index + 1}: ${erroresItem.join(', ')}`);
                }
            });
        }

        // Mostrar errores
        if (errors.length) {
            alert(errors[0]);
            return false;
        }
        return true;
    };

    useEffect(() => {
        if (usuarioSelected && (Number(totalFinal) > Number(usuarioSelected.limite_compra))) {
            alert("El usuario seleccionado para autorizar la orden de compra no tiene permisos para el monto total. Por favor, seleccione otro usuario autorizado")
        }
    }, [totalFinal, usuarioSelected])

    // Efecto secundario para calcular el total cuando cambia la lista de datos
    useEffect(() => {
        getTotal(datosLista, setsubtotal);
    }, [datosLista]);

    const columns = useMemo(
        () => [
            {
                accessorKey: 'checked',
                header: 'De Stock',
                size: 1,
                Cell: ({ row }) => (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={row.original.checked} // Asegurar que siempre haya un valor booleano
                                onChange={(e) => handleChecked(row.index, e.target.checked)}
                            />
                        }
                        labelPlacement="start"

                    />
                ),
            },
            {
                accessorKey: 'cantidad',
                header: 'Cantidad',
                size: 40,
                Cell: ({ row }) => (
                    <TextField
                        type="number"
                        size="small"
                        fullWidth
                        value={row.original.cantidad}
                        inputProps={{ min: 0 }}
                        onKeyDown={bloquearSignoNegativo}
                        onChange={(e) => handleCantidadChange(row.index, e.target.value)}
                    // style={{ width: '90px' }}
                    />
                ),
            },
            {
                accessorKey: 'id_articulo',
                header: 'Artículo',
                size: 130,
                Cell: ({ row }) =>
                    row.original.checked ? (
                        <Autocomplete
                            options={articulos}
                            fullWidth
                            getOptionLabel={(option) => (option ? option.nombre || '' : '')}
                            value={articulos.find((articulo) => articulo.id_articulo === row.original.id_articulo) || null}
                            onChange={(event, newValue) => handleArticuloChange(row.index, newValue)}
                            renderInput={(params) => <TextField {...params} label="Artículo" size="small"
                            />}
                        />
                    ) : (
                        <>

                            <Select
                                value={row.original.id_unidad_medida}
                                onChange={(e) => handleMedidaChange(row.index, e.target.value)}
                                size='small'
                                focused
                                fullWidth
                                style={{ width: '100px' }}
                                label="Unidad de medida"
                            >
                                {medidas && medidas.map((elemento) => (
                                    <MenuItem key={elemento.id} value={elemento.id}>
                                        {elemento.descripcion}
                                    </MenuItem>
                                ))}
                            </Select>
                            <TextField
                                label="Material/Servicio"
                                size="small"
                                fullWidth
                                multiline
                                style={{ width: '230px' }}
                                value={row.original.material}
                                onChange={(e) => handleMaterialChange(row.index, e.target.value)}
                            />
                        </>
                    ),
            },
            {
                accessorKey: 'precio_unitario',
                header: 'Precio',
                size: 45,
                Cell: ({ row }) => (
                    <TextField
                        type="number"
                        size="small"
                        fullWidth
                        value={row.original.precio_unitario}
                        inputProps={{ min: 0 }}
                        onKeyDown={bloquearSignoNegativo}
                        onChange={(e) => handlePrecioChange(row.index, e.target.value)}
                    // style={{ width: '80px' }}
                    />
                ),
            },
            {
                accessorKey: 'bonificacion_pesos',
                header: 'Bonif. $',
                size: 45,
                Cell: ({ row }) => (
                    <TextField
                        type="number"
                        fullWidth
                        size="small"
                        value={row.original.bonificacion_pesos ?? ''}
                        inputProps={{ min: 0 }}
                        onKeyDown={bloquearSignoNegativo}
                        onChange={(e) => handleBonificacionPesosChange(row.index, e.target.value)}
                    // style={{ width: '80px' }}
                    />
                ),
            },
            {
                accessorKey: 'bonificacion_porcentaje',
                header: 'Bonif. %',
                size: 45,
                Cell: ({ row }) => (
                    <TextField
                        type="number"
                        fullWidth
                        size="small"
                        value={row.original.bonificacion_porcentaje ?? ''}
                        inputProps={{ min: 0 }}
                        onKeyDown={bloquearSignoNegativo}
                        onChange={(e) => handleBonificacionPorcentajeChange(row.index, e.target.value)}
                    // style={{ width: '80px' }}
                    />
                ),
            },
            {
                accessorKey: 'subtotal',
                header: 'Subtotal',
                size: 45,
                Cell: ({ row }) => formatoImporte(row.original.subtotal),
            },
        ],
        [datosLista, articulos, medidas]
    );

    const tableTheme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: globalTheme.palette.mode,
                    primary: globalTheme.palette.primary, //primary color for the table
                    info: {
                        main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
                    },
                    background: {
                        default:
                            globalTheme.palette.mode === "light"
                                ? "rgb(234, 239, 241)"
                                : "#000", //pure black table in dark mode for fun
                    },
                },
                typography: {
                    button: {
                        textTransform: "none", //customize typography styles for all buttons in table by default
                        fontSize: "1rem",
                    },
                },
                components: {
                    MuiTooltip: {
                        styleOverrides: {
                            tooltip: {
                                fontSize: "0.8rem", //larger tooltip font size                                
                            }
                        }
                    }
                }
            }), [globalTheme]);

    const initialState = {
        density: "compact",
        columnPinning: { right: ["mrt-row-actions"] },
        columnSizing: {
            "mrt-row-actions": 20,
        }
    };

    const tableHeadCellProps = {
        align: "center",
        sx: {
            fontSize: 14,
            color: "black",
            fontWeight: "normal",
            paddingTop: 1,
            paddingBottom: 1,
            backgroundColor: "#D4E6F1",
            borderColor: "#FDFEFE",
        },
    };

    const handleCloseNotificacion = () => {
        setNotificacion({ ...notificacion, open: false });
    };

    const [inputValue, setInputValue] = useState();
    const timeoutRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const getProveedores = async (busqueda) => {
        if (!busqueda) return;

        setLoading(true);

        try {
            const res = await fetch(
                UrlApi + `/proveedores_padron/search?query=${encodeURIComponent(busqueda)}`
            );
            const data = await res.json();
            setProveedores(data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div>
            <Container maxWidth="xl">
                <Title
                    titulo="Generar nueva orden de compra"
                    handleClose={handleClose}
                />
                <form onSubmit={guardarOrdenCompra} autoComplete='off'>
                    <Box backgroundColor="#F4F6F6"
                        mt={0.5}
                        p={3}
                        mb={5}
                        border={0.5}
                        borderColor={"#ABB2B9"}
                        borderRadius={4}>
                        <Grid container spacing={2} alignItems='center' >
                            <Grid item xs={3} alignItems='flex-start'>
                                <Autocomplete
                                    required
                                    sx={{ backgroundColor: "white" }}
                                    disableClearable
                                    placeholder="Nombre, CUIT o Sisven ID"
                                    options={proveedores || [{}]}
                                    value={proveedorSelected}
                                    inputValue={inputValue}
                                    loading={loading}
                                    loadingText={"Cargando..."}
                                    onChange={(e, value) => {
                                        setproveedorSelected(value);
                                    }}
                                    noOptionsText={"No existe proveedor"}
                                    onInputChange={(e, value, reason) => {
                                        setInputValue(value);

                                        if (timeoutRef.current) {
                                            clearTimeout(timeoutRef.current);
                                            timeoutRef.current = null;
                                        }

                                        if (value?.length >= 2) {
                                            timeoutRef.current = setTimeout(() => {
                                                getProveedores(value);
                                                timeoutRef.current = null;
                                            }, 300);
                                        } else {
                                            setProveedores([]);
                                        }
                                    }}
                                    getOptionLabel={(option) =>
                                        `${option?.denominacion?.trim()} (${option?.cuit})`
                                    }
                                    renderOption={(props, option) => (
                                        <Box
                                            component="li"
                                            key={option.denominacion}
                                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                            {...props}
                                        >
                                            {`${option?.denominacion?.trim()} (${option?.cuit}) `}
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            focused
                                            fullWidth
                                            placeholder="Tipee para buscar proveedores.."
                                            {...params}
                                            variant="outlined"
                                            size="small"
                                            label="Proveedor"
                                            required={proveedorSelected === null}
                                        />
                                    )}
                                />

                                {/* <Autocomplete
                                    focused
                                    size="small"
                                    style={style}
                                    noOptionsText={"Proveedor INEXISTENTE"}
                                    options={proveedores}
                                    autoHighlight
                                    getOptionLabel={(proveedor) => proveedor.nombre_fantasia ?? proveedor.razon_social}
                                    onChange={(event, value) => setproveedorSelected(value)}
                                    renderOption={(props, option) => (
                                        <Box
                                            component="li"
                                            key={option.nombre_fantasia}
                                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                            {...props}
                                        >
                                            {option.nombre_fantasia ?? option.razon_social} - {option.nro_cuit}
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            focused
                                            required
                                            fullWidth={true}
                                            placeholder="Tipee para buscar proveedores.."
                                            {...params}
                                            variant='outlined'
                                            size="small"
                                            label="Proveedores "
                                            inputProps={{
                                                ...params.inputProps,
                                            }
                                            }
                                        />
                                    )}
                                /> */}
                            </Grid>

                            <Grid item xs={2}>
                                <FormControl fullWidth={true} size="small" focused color="primary" required >
                                    <InputLabel id="lbl_estado">Condicion De Venta</InputLabel>
                                    <Select
                                        variant='outlined'
                                        minHeight='20px'
                                        onSelect={proveedorSelected && proveedorSelected.id_condicionventa}
                                        name='condicion_venta'
                                        value={condVentaNew}
                                        style={style}
                                        onChange={setearCondicion}
                                        label="Condición de venta">
                                        {condiciones ? condiciones.map(elemento => (
                                            <MenuItem key={elemento.id} value={elemento.id}>
                                                {elemento.condicion}
                                            </MenuItem>
                                        )) : null}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={2}>
                                <FormControl fullWidth={true} style={style} focused color="primary" required size="small">
                                    <InputLabel id="lbl_estado">Moneda</InputLabel>
                                    <Select
                                        required
                                        variant='outlined'
                                        name='tipo_moneda'
                                        value={datosFormulario.tipo_moneda}
                                        onChange={almacenar}
                                        label="Moneda">
                                        {tipoMoneda ? tipoMoneda.map(elemento => (
                                            <MenuItem key={elemento.id} value={elemento.id}>
                                                {elemento.valor}
                                            </MenuItem>
                                        )) : null}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={2}>
                                <FormControl fullWidth={true} style={style} focused color="primary" required size="small">
                                    <InputLabel id="lbl_estado">Facturar a </InputLabel>
                                    <Select
                                        required
                                        variant='outlined'
                                        name='facturar_a_empresa'
                                        value={datosFormulario.facturar_a_empresa}
                                        onChange={almacenar}
                                        label="Facturar a ">
                                        {(empresas ?? []).map(elemento => (
                                            <MenuItem key={elemento.idempresa} value={elemento.idempresa}>
                                                {elemento.empresa}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>


                            <Grid item xs={1}>
                                <FormControlLabel
                                    value="start"
                                    control={
                                        <Checkbox
                                            name='iva_incluido'
                                            onClick={handleOnClickCheckBox}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 35 } }} />}
                                    label="Impuestos incluidos "
                                    labelPlacement="start"
                                />
                            </Grid>

                            <Grid item xs={1} ml={3}>
                                <FormControlLabel
                                    value="start"
                                    control={
                                        <Checkbox
                                            name='pago_anticipado'
                                            onClick={handleOnClickCheckBox}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 35 } }} />}
                                    label="Pago anticipado"
                                    labelPlacement="start"
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} alignItems='center' mt={0.3} mb={3}>
                            <Grid item xs={3}>
                                <TextField
                                    name='id_sucursal'
                                    select
                                    size='small'
                                    style={style}
                                    required
                                    focused
                                    color="primary"
                                    placeholder='Elija una sucursal'
                                    value={datosFormulario.id_sucursal}
                                    onChange={almacenar}
                                    label="Sucursal"
                                >
                                    {sucursales ? sucursales.map(elemento => (
                                        <MenuItem key={elemento.id} value={elemento.id}>
                                            {elemento.nombre}
                                        </MenuItem>
                                    )) : null}
                                </TextField>
                            </Grid>

                            <Grid item xs={3}>
                                <FormControl style={style} focused color="primary" size='small'>
                                    <InputLabel id="lbl_movil">Movil</InputLabel>
                                    <Select
                                        name='id_vehiculo'
                                        value={datosFormulario.id_vehiculo}
                                        onChange={almacenar}
                                        label="Movil">
                                        {vehiculos ? vehiculos.map(elemento => (
                                            <MenuItem key={elemento.id} value={elemento.id}>
                                                {elemento.modelo}  -  {elemento.patente}
                                            </MenuItem>
                                        )) : null}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={3}>
                                <TextField
                                    name="fecha_entrega"
                                    size='small'
                                    focused
                                    style={style}
                                    label="Fecha de entrega"
                                    value={moment(datosFormulario.fecha_entrega).format("YYYY-MM-DD")}
                                    onChange={almacenar}
                                    type="date"
                                    inputProps={{
                                        min: moment(new Date()).format("YYYY-MM-DD")
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth size="small" focused required>
                                    <InputLabel>Autoriza orden</InputLabel>
                                    <Select
                                        variant="outlined"
                                        value={usuarioSelected || null}
                                        onChange={(e) => setusuarioSelected(e.target.value)}
                                        label="Autoriza orden"
                                        style={style}
                                    >
                                        {usuarios.map((el) => (
                                            <MenuItem key={el.id} value={el.usuario}>
                                                {el.nombre_apellido}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <ThemeProvider theme={tableTheme}>
                            <MaterialReactTable
                                enableColumnResizing
                                columns={columns}
                                data={datosLista}
                                enableRowActions
                                positionActionsColumn='last'
                                muiTableHeadCellProps={tableHeadCellProps}
                                muiTableBodyCellProps={({ row, column }) => ({
                                    align: 'left',
                                    sx: {
                                        backgroundColor: '#ffffff',
                                        color: 'black',
                                        borderColor: 'black',
                                    },
                                })}
                                enableColumnActions={false}
                                enableDensityToggle={false}
                                enableExpandAll={false}
                                enableToolbarInternalActions={true}
                                editingMode='row'
                                enableStickyFooter
                                getRowId={(row) => row.id}
                                enableEditing
                                initialState={initialState}
                                renderRowActions={({ row, table }) => (
                                    <Box sx={{}}>
                                        <IconButton
                                            disabled={row.index === 0 && datosLista.length === 1}
                                            color="error"
                                            onClick={() => deshacerAlmacenar(row.index)}
                                        >
                                            <Delete />
                                        </IconButton>
                                        {row.index === datosLista.length - 1 && (
                                            <IconButton color="primary" onClick={agregarLinea}>
                                                <AddCircleOutline />
                                            </IconButton>
                                        )}
                                    </Box>
                                )}
                                enableColumnFilters={false}
                                enableHiding={false}
                                enableBottomToolbar={true}
                                enableTopToolbar={false}
                                enableColumnDragging={false}
                                enableColumnOrdering
                                localization={MRT_Localization_ES} />
                        </ThemeProvider>

                        <Grid container alignItems="center" columnGap={2} rowGap={1} mt={1}>
                            <Box sx={{ width: { xs: "100%", sm: 360 }, maxWidth: "100%", py: 1 }}>
                                <Stack spacing={1}>
                                    {presupuestos.length > 0 ? (
                                        presupuestos.map((archivo) => (
                                            <AdjuntoFileCard
                                                key={archivo.id}
                                                title="Presupuesto"
                                                idTipoAdjunto={archivo.id}
                                                hasFile
                                                fileName={archivo.nombre}
                                                showDownloadAction
                                                showViewAction
                                                onFileChange={() => {}}
                                                onRemove={() => quitarPresupuesto(archivo)}
                                                onView={() =>
                                                    ViewUploadFile(
                                                        `${archivo.id_archivo}-${archivo.nombre}`,
                                                        archivo.extension
                                                    )
                                                }
                                                onDownload={() =>
                                                    DownloadFiles(`${archivo.id_archivo}-${archivo.nombre}`)
                                                }
                                            />
                                        ))
                                    ) : (
                                        <AdjuntoField
                                            title="Añadir presupuesto"
                                            idTipoAdjunto={0}
                                            loadingId={cargandoPresupuesto ? 0 : null}
                                            hasFile={false}
                                            accept="*/*"
                                            error={errorPresupuesto}
                                            cardProps={{
                                                showRemoveAction: false,
                                                showDownloadAction: false,
                                            }}
                                            onFileChange={handlePresupuestoChange}
                                            onRemove={() => {}}
                                        />
                                    )}
                                </Stack>
                            </Box>

                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: { sm: "auto" }, flexWrap: "wrap" }}>
                                <TextField
                                    disabled={!!bonificacionPorcentaje}
                                    focused
                                    variant='outlined'
                                    color='primary'
                                    label='Bonificación $'
                                    size="small"
                                    type="number"
                                    name='bonificacion'
                                    sx={{ width: 150, backgroundColor: "#ffffff" }}
                                    value={bonificacionPesos}
                                    inputProps={{ min: 0 }}
                                    onKeyDown={bloquearSignoNegativo}
                                    onChange={(e) => {
                                        if (!esValorNoNegativo(e.target.value)) return;
                                        setBonificacionPesos(e.target.value ? e.target.value : null);
                                    }}
                                />
                                <TextField
                                    disabled={!!bonificacionPesos}
                                    focused
                                    type="number"
                                    variant='outlined'
                                    color='primary'
                                    label='Bonificación %'
                                    size="small"
                                    name='bonificacion'
                                    sx={{ width: 150, backgroundColor: "#ffffff" }}
                                    value={bonificacionPorcentaje}
                                    inputProps={{ min: 0 }}
                                    onKeyDown={bloquearSignoNegativo}
                                    onChange={(e) => {
                                        if (!esValorNoNegativo(e.target.value)) return;
                                        setBonificacionPorcentaje(e.target.value ? e.target.value : null);
                                    }}
                                />
                                <TextField
                                    disabled
                                    focused
                                    sx={{ width: 140, backgroundColor: "#ffffff" }}
                                    variant='outlined'
                                    color='primary'
                                    autoComplete='off'
                                    label='Total'
                                    name='total'
                                    size="small"
                                    value={totalFinal !== null ? totalFinal?.toLocaleString('es-AR', { minimumFractionDigits: 2 }) : 0}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                />
                            </Box>
                        </Grid>


                        <Box sx={{ '& > :not(style)': { m: 1, mt: 1 }, }} autoComplete="off" >
                            <TextField
                                placeholder="Comentarios internos"
                                variant='outlined'
                                autoComplete='off'
                                focused
                                style={style}
                                size="small"
                                name="comentarios_internos"
                                id="id"
                                multiline
                                label="Comentarios internos COMPRAS "
                                color="primary"
                                onChange={almacenar}
                                value={datosFormulario.comentarios_internos}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>
                        <Box sx={{ '& > :not(style)': { m: 1, mt: 1 }, }} autoComplete="off" >
                            <TextField
                                focused
                                variant='outlined'
                                style={style}
                                color='primary'
                                size="small"
                                autoComplete='off'
                                label='Observaciones que se imprimen en la OC '
                                name='observaciones'
                                value={datosFormulario.observaciones}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment
                                            position="start"
                                        ></InputAdornment>)
                                }} />
                        </Box>
                        <Grid mt={1} container direction="row" justifyContent="space-between" alignItemns="center">
                            <Button
                                variant="contained"
                                color="error"
                                onClick={handleClose}
                            >Volver</Button>
                            <Button
                                variant="contained"
                                disabled={disbtn}
                                type="submit"
                                color="success">
                                Guardar Orden
                            </Button>
                        </Grid>
                    </Box>
                </form>

                {notificacion && notificacion.open ? (
                    <Notify
                        mensaje={notificacion.mensaje}
                        open={notificacion.open}
                        color={notificacion.color}
                        handleClose={handleCloseNotificacion}
                        severity={notificacion.severity}
                    />
                ) : null}

                {modalVacio ? (
                    <Modalcondicionnull
                        open={setmodalVacio}
                        proveedor={proveedorSelected}
                    />
                ) : null}
            </Container>

        </div >
    )
};

//========================================================================
/*----- Component --------------------------------------------------------/
// Developer     : Candela Grosso   
// Creation Date : 28/11/2023
// Version       : 1.0  
// Description   :  Con este componente el usuario es capaz de generar ordenes de compras desde 0 sin la necesidad de partir desde un requerimiento
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   : 2026-02-27
// Change by     : Magali Perea
// Change description: - 
//========================================================================*/
